import store from '../store';
import moment from "moment";

const plannerFunctions = {
    exam_table_data: ["id", "name", "reference", "examination_date", "location_name", "room_name"],
    certificate_table_data: ["certificate_number", "name", "status", "issueing_date", "valid_until"],
    dossier_table_data: ["id", "name", "status", "is_closed"],
    company_table_data: ["id", "name", "reference", "phonenumber", "website"],
    contact_table_data: ["id", "name", "phonenumber", "mobilenumber"],
    candidate_table_data: ["id", "name", "phonenumber", "mobilenumber"],
    room_table_data: ["id", "name", "location_name", "minimum_capacity", "maximum_capacity"],
    scheme_table_data: ["id", "name", "reference", "scheme_owner", "end_result"],
    person_fields: ['date_of_birth', 'phonenumber', 'mobilenumber', 'billingnumber', 'gender', 'place_of_birth', 'country_of_birth_id', 'nationality_id', 'financial_name'],
    //PLANNER FUNCTIONS
    getColor(title) {
        if (title === "Praktijk" || title === "Praktijk VOP-LS" || title === "Praktijk IVWV-HS-LS") {
            return "#CCFFFF";
        }
        else if (title === "Certificatie" || title === "Certificatietoets" || title === "Certificatietoets IVWV-HS-LS" || title === "Certificatietoets Theorie") {
            return "#FFCC99";
        }
        else if (title === "Schakelbericht" || title === "Schakelbericht IVWV-HS-LS") {
            return "#ff99cc";
        }
        else if (title === "Basis" || title === "Basistoets" || title === "Basistoets IVWV-HS-LS" || title === "Basistoets theorie" || title === "Basistoets Theorie") {
            return "#FFFF99";
        }
        else if (title === "Theorie - meerkeuzevragen" || title === "Theorie - openvragen" || title === "Theorie" || title === "Theorie VOP-LS" || title === "Theorie VEWA VP/AVP" || title === "Theorie Scope 12 AC" || title === "Theorie Scope 12 DC + IB22") {
            return "#d8e4bc";
        }
        else {
            return "lightskyblue";
        }
    },
    getHexRgbColor(color, export_type) {
        if(export_type === 'pdf') {
            return color;
        }
        else if (color === "#CCFFFF") {
            return "RGB(204, 255, 255)";
        }
        else if (color === "#FFCC99") {
            return "RGB(255, 204, 153)";
        }
        else if (color === "#ff99cc") {
            return "RGB(255, 153, 204)";
        }
        else if (color === "#FFFF99") {
            return "RGB(255, 255, 153)";
        }
        else if (color === "#d8e4bc") {
            return "RGB(216, 228, 188)";
        }
        else if (color === "black") {
            return "RGB(0, 0, 0)";
        }
        else if (color === "white") {
            return "RGB(255, 255, 255)";
        }
        else if (color === "grey") {
            return "RGB(128, 128, 128)";
        }
        else if (color === "#56d65b") {
            return "RGB(86, 214, 91)";
        }
        else if (color === "#ff7f75") {
            return "RGB(255, 127, 117)";
        }
        else {
            return "RGB(0, 191, 255)";
        }
    },
    backgroundColor(cesuur, item) {
        if (item.status === "exempt" || item.status === "absent" || parseInt(cesuur) === 0) {
            return "grey";
        }
        if (parseInt(cesuur) > parseInt(item.result) || !item.result) {
            return "#ff7f75";
        }
        return "#56d65b";
    },
    getTitle(session_name) {
        if (session_name === "Praktijk") {
            return "Praktijk";
        }
        else if (session_name === "Certficatietoets" || session_name === "Certificatie toets" || session_name === "Certificatietoets" || session_name === "certificatietoets") {
            return "Certificatie";
        }
        else if (session_name === "Scakelbericht" || session_name === "Schakelbericht") {
            return "Schakelbericht";
        }
        else if (session_name === "Basis" || session_name === "Basistoets" || session_name === "Basistoets IVWV-HS-LS" || session_name === "Basistoets theorie" || session_name === "Basistoets Theorie" || session_name === "Basis toets") {
            return "Basis";
        }
        else if (session_name === "Theorie - meerkeuzevragen" || session_name === "Theorie - Meerkeuzevragen" || session_name === "Theory multiple choice" ||
            session_name === "Meerkeuze vragen" || session_name === "Theorie meerkeuze" || session_name === "Theorietoets meerkeuze" || session_name === "Meerkeuze") {
            return "Theorie - meerkeuzevragen";
        }
        else if (session_name === "Theorie - openvragen" || session_name === "Openvragen" || session_name === "Theorie open" || session_name === "Theorie open vragen" || session_name === "Theorie openvragen") {
            return "Theorie - openvragen";
        }
        else {
            return session_name;
        }
    },
    exportCalendar(export_type, resources) {
        let html = this.generateTableHeader(export_type) + '<tr><th></th>';
        let resource_events = [];
        resources.forEach(resource => {
            //DOING 2 COLUMNS FOR EACH CANDIDATE IN CASE IF HE`S SESSIONS INTERSECT
            html += '<th colspan="2">' + resource._resource.title + '</th>';
            let events = [];
            resource.getEvents().forEach(event => {
                let duration = moment.duration(moment(event._instance.range.end).diff(moment(event._instance.range.start)));
                //ADJUST MINUTES TO % 5
                let start_minutes = Math.floor(moment.utc(event._instance.range.start).minutes() / 5) * 5;
                let end_minutes = Math.floor(moment.utc(event._instance.range.end).minutes() / 5) * 5;
                events.push({
                    title: event._def.title,
                    backgroundColor: event.backgroundColor ? event.backgroundColor : 'white',
                    textColor: event.textColor ? event.textColor : 'black',
                    start: moment.utc(event._instance.range.start).minute(start_minutes).format("HH:mm"),
                    end: moment.utc(event._instance.range.end).minute(end_minutes).format("HH:mm"),
                    duration: Math.floor(((duration.hours() * 60) + duration.minutes()) / 5), //SAVE IN STEPS % 5 MINUTES
                });
            });
            resource_events.push(events);
        });
        html += '</tr>';
        let times = this.generateTimes();
        for (let i = 0; i < times.length; i++) {
            html += '<tr>';
            //FIRST COLUMN WITH TIME
            if(i === 0 || i % 3 === 0) {
                html += '<td>' + times[i] + '</td>';
            }
            else {
                html += '<td></td>';
            }
            //RESOURCE COLUMNS
            resource_events.forEach(events => {
                //CHECK IF CANDIDATE`S SESSIONS INTERSECT
                let duplicated_event_exists = false;
                for (let x = 0; x < events.length; x++) {
                    for (let y = 0; y < events.length; y++) {
                        if(x !== y && moment(events[x].start, "HH:mm").isBetween(moment(events[y].start, "HH:mm"), moment(events[y].end, "HH:mm"))) {
                            duplicated_event_exists = true;
                            break;
                        }
                    }
                    if(duplicated_event_exists) {
                        break;
                    }
                }
                let event_exists_counter = 0;
                for (let x = 0; x < events.length; x++) {
                    if(events[x].start === times[i]) {
                        if(duplicated_event_exists) {
                            html += '<td style="color: ' + this.getHexRgbColor(events[x].textColor, export_type) + '; ' +
                                'background-color: ' + this.getHexRgbColor(events[x].backgroundColor, export_type) + ';" ' +
                                'rowspan="' + events[x].duration + '">' + events[x].start + ' - ' + events[x].end + '<br/>' + events[x].title + '</td>';
                        }
                        else {
                            //TAKE BOTH COLUMNS BECAUSE CANDIDATE`S SESSIONS NOT INTERSECT
                            html += '<td colspan="2" style="color: ' + this.getHexRgbColor(events[x].textColor, export_type) + '; ' +
                                'background-color: ' + this.getHexRgbColor(events[x].backgroundColor, export_type) + ';" ' +
                                'rowspan="' + events[x].duration + '">' + events[x].start + ' - ' + events[x].end + '<br/>' + events[x].title + '</td>';
                        }
                        event_exists_counter++;
                    }
                    else if(moment(times[i], "HH:mm").isBetween(moment(events[x].start, "HH:mm"), moment(events[x].end, "HH:mm"))) {
                        event_exists_counter++;
                    }
                }
                if(event_exists_counter === 0) {
                    html += '<td colspan="2"></td>';
                }
                else if(duplicated_event_exists && event_exists_counter === 1) {
                    html += '<td></td>';
                }
            });
            html += '</tr>';
        }
        html += '</table>';

        return html;
    },
    exportDossier(export_type, record, record_results) {
        let html = this.generateTableHeader(export_type); //OPEN MAIN TABLE TAG
        html += this.generateTableSubheader(export_type, record.name, 2);
        html += this.generateSimpleRow('status', store.getters.translate(record.status));
        html += this.generateSimpleRow('scheme', record.scheme.name);
        html += this.generateSimpleRow('exam', record.latest_exam.name);
        html += this.generateSimpleRow('candidate', record.candidate.name);
        html += this.generateSimpleRow('agreed_with_terms_on', record.agreed_with_terms_on);
        html += this.generateSimpleRow('tags', record.tags.join(", "));
        html += this.generateBooleanRow(export_type, 'is_closed', record.is_closed);
        //EXAMS
        if(record.exams && record.exams.length > 0) {
            html += '<tr><td colspan="2" style="padding: 0;"/></tr>';
            html += '<tr><td colspan="2" style="padding: 0;">'; //OPEN TR/TD IN MAIN TABLE
            html += this.generateTableHeader(export_type); //OPEN EXAM TABLE TAG
            html += this.generateTableSubheader(export_type, store.getters.translate('exams'), this.exam_table_data.length);
            record_results.forEach((record_result, key) => {
                if (!record.exams[key].re_examination || record.exams.length === 1) {
                    //EXAMS HEADER
                    html += this.generateAdvancedHeaders(this.exam_table_data);
                    //EXAMS DATA
                    html += this.generateAdvancedRow(record.exams[key], this.exam_table_data);
                    html += this.generateResultsRow(export_type, record_result);
                    record_results.forEach((record_result_2, key2) => {
                        if (record.exams[key2].re_examination && record.exams[key2].re_exam_id === record.exams[key].id) {
                            html += this.generateAdvancedRow(record.exams[key2], this.exam_table_data);
                            html += this.generateResultsRow(export_type, record_result_2);
                            record_results.forEach((record_result_3, key3) => {
                                if (record.exams[key3].re_examination && record.exams[key3].re_exam_id === record.exams[key2].id) {
                                    html += this.generateAdvancedRow(record.exams[key3], this.exam_table_data);
                                    html += this.generateResultsRow(export_type, record_result_3);
                                    record_results.forEach((record_result_4, key4) => {
                                        if (record.exams[key4].re_examination && record.exams[key4].re_exam_id === record.exams[key3].id) {
                                            html += this.generateAdvancedRow(record.exams[key4], this.exam_table_data);
                                            html += this.generateResultsRow(export_type, record_result_4);
                                            record_results.forEach((record_result_5, key5) => {
                                                if (record.exams[key5].re_examination && record.exams[key5].re_exam_id === record.exams[key4].id) {
                                                    html += this.generateAdvancedRow(record.exams[key5], this.exam_table_data);
                                                    html += this.generateResultsRow(export_type, record_result_5);
                                                    record_results.forEach((record_result_6, key6) => {
                                                        if (record.exams[key6].re_examination && record.exams[key6].re_exam_id === record.exams[key5].id) {
                                                            html += this.generateAdvancedRow(record.exams[key6], this.exam_table_data);
                                                            html += this.generateResultsRow(export_type, record_result_6);
                                                            record_results.forEach((record_result_7, key7) => {
                                                                if (record.exams[key7].re_examination && record.exams[key7].re_exam_id === record.exams[key6].id) {
                                                                    html += this.generateAdvancedRow(record.exams[key7], this.exam_table_data);
                                                                    html += this.generateResultsRow(export_type, record_result_7);
                                                                }
                                                            });
                                                        }
                                                    });
                                                }
                                            });
                                        }
                                    });
                                }
                            });
                        }
                    });
                }
            });
            html += '</table>'; //CLOSE EXAM TABLE TAG
            html += '</td></tr>'; //CLOSE TR/TD IN MAIN TABLE
        }
        html += this.generateIncludableTable(export_type, 'certificates', record.certificates, this.certificate_table_data);
        html += '</table>'; //CLOSE MAIN TABLE TAG

        return html;
    },
    exportCompany(export_type, record, usual_fields) {
        let html = this.generateTableHeader(export_type);
        html += this.generateTableSubheader(export_type, record.name, 2);
        usual_fields.forEach(field => {
            html += this.generateSimpleRow(field.name, record[field.name]);
        });
        record.emailaddresses.forEach(email => {
            html += this.generateSimpleRow('email', email.emailaddress);
        });
        record.addresses.forEach(address => {
            html += this.generateSimpleRow('address', address.name);
        });
        html += this.generateIncludableTable(export_type, 'contacts', record.contacts, this.contact_table_data);
        html += this.generateIncludableTable(export_type, 'candidates', record.candidates, this.candidate_table_data);
        html += '</table>';

        return html;
    },
    exportPerson(export_type, user_type, record, usual_fields) {
        let html = this.generateTableHeader(export_type);
        html += this.generateTableSubheader(export_type, record.name, 2);
        usual_fields.forEach(field => {
            if(field.name === 'jobtitle') {
                html += this.generateSimpleRow(field.name, record[field.name]);
            }
            else if(field.name === 'preferred_certificate_language') {
                html += this.generateSimpleRow(field.name, store.getters.translate(record[field.name]));
            }
            else if(field.name === 'is_dyslexic' || field.name === 'is_dyscalc') {
                html += this.generateBooleanRow(export_type, field.name, record[field.name]);
            }
            else if(field.name === 'type') {
                html += this.generateSimpleRow(field.name, record[field.name].join(", "));
            }
            else if(field.name === 'country_of_birth_id' || field.name === 'nationality_id') {
                html += this.generateSimpleRow(field.name, record.person[field.name.replace('_id', '')]);
            }
            else if(field.name === 'gender') {
                html += this.generateSimpleRow(field.name, store.getters.translate(record.person[field.name]));
            }
            else {
                html += this.generateSimpleRow(field.name, record.person[field.name]);
            }
        });
        if(record.person.user) {
            html += this.generateSimpleRow('user_email', record.person.user.email);
        }
        record.person.emailaddresses.forEach(email => {
            html += this.generateSimpleRow('email', email.emailaddress);
        });
        record.person.addresses.forEach(address => {
            html += this.generateSimpleRow('address', address.name);
        });
        if(user_type === 'candidate') {
            html += this.generateIncludableTable(export_type, 'certificates', record.certificates, this.certificate_table_data);
            //EXAMS
            if(record.exams_for_export && record.exams_for_export.length > 0) {
                html += '<tr><td colspan="2" style="padding: 0;"/></tr>';
                html += '<tr><td colspan="2" style="padding: 0;">'; //OPEN TR/TD IN MAIN TABLE
                html += this.generateTableHeader(export_type); //OPEN EXAM TABLE TAG
                html += this.generateTableSubheader(export_type, store.getters.translate('exams'), this.exam_table_data.length);
                record.record_results.forEach((record_result, key) => {
                    if (!record.exams_for_export[key].re_examination || record.exams_for_export.length === 1) {
                        //EXAMS HEADER
                        html += this.generateAdvancedHeaders(this.exam_table_data);
                        //EXAMS DATA
                        html += this.generateAdvancedRow(record.exams_for_export[key], this.exam_table_data);
                        html += this.generateResultsRow(export_type, record_result);
                        record.record_results.forEach((record_result_2, key2) => {
                            if (record.exams_for_export[key2].re_examination && record.exams_for_export[key2].re_exam_id === record.exams_for_export[key].id) {
                                html += this.generateAdvancedRow(record.exams_for_export[key2], this.exam_table_data);
                                html += this.generateResultsRow(export_type, record_result_2);
                                record.record_results.forEach((record_result_3, key3) => {
                                    if (record.exams_for_export[key3].re_examination && record.exams_for_export[key3].re_exam_id === record.exams_for_export[key2].id) {
                                        html += this.generateAdvancedRow(record.exams_for_export[key3], this.exam_table_data);
                                        html += this.generateResultsRow(export_type, record_result_3);
                                        record.record_results.forEach((record_result_4, key4) => {
                                            if (record.exams_for_export[key4].re_examination && record.exams_for_export[key4].re_exam_id === record.exams_for_export[key3].id) {
                                                html += this.generateAdvancedRow(record.exams_for_export[key4], this.exam_table_data);
                                                html += this.generateResultsRow(export_type, record_result_4);
                                                record.record_results.forEach((record_result_5, key5) => {
                                                    if (record.exams_for_export[key5].re_examination && record.exams_for_export[key5].re_exam_id === record.exams_for_export[key4].id) {
                                                        html += this.generateAdvancedRow(record.exams_for_export[key5], this.exam_table_data);
                                                        html += this.generateResultsRow(export_type, record_result_5);
                                                        record.record_results.forEach((record_result_6, key6) => {
                                                            if (record.exams_for_export[key6].re_examination && record.exams_for_export[key6].re_exam_id === record.exams_for_export[key5].id) {
                                                                html += this.generateAdvancedRow(record.exams_for_export[key6], this.exam_table_data);
                                                                html += this.generateResultsRow(export_type, record_result_6);
                                                                record.record_results.forEach((record_result_7, key7) => {
                                                                    if (record.exams_for_export[key7].re_examination && record.exams_for_export[key7].re_exam_id === record.exams_for_export[key6].id) {
                                                                        html += this.generateAdvancedRow(record.exams_for_export[key7], this.exam_table_data);
                                                                        html += this.generateResultsRow(export_type, record_result_7);
                                                                    }
                                                                });
                                                            }
                                                        });
                                                    }
                                                });
                                            }
                                        });
                                    }
                                });
                            }
                        });
                    }
                });
                html += '</table>'; //CLOSE EXAM TABLE TAG
                html += '</td></tr>'; //CLOSE TR/TD IN MAIN TABLE
            }
            html += this.generateIncludableTable(export_type, 'dossiers', record.dossiers, this.dossier_table_data);
            html += this.generateIncludableTable(export_type, 'companies', record.companies, this.company_table_data);
            html += this.generateIncludableTable(export_type, 'contacts', record.contacts, this.contact_table_data);
        }
        else if(user_type === 'assessor') {
            html += this.generateIncludableTable(export_type, 'rooms', record.rooms, this.room_table_data);
            html += this.generateIncludableTable(export_type, 'schemes', record.schemes, this.scheme_table_data);
        }
        else if(user_type === 'contact') {
            html += this.generateIncludableTable(export_type, 'companies', record.companies, this.company_table_data);
            html += this.generateIncludableTable(export_type, 'candidates', record.candidates, this.candidate_table_data);
        }
        html += '</table>';

        return html;
    },
    generateIncludableTable(export_type, text, data, headers) {
        let html = '';
        if(data && data.length > 0) {
            html += '<tr><td colspan="2" style="padding: 0;"/></tr>';
            html += '<tr><td colspan="2" style="padding: 0;">'; //OPEN TR/TD IN MAIN TABLE
            html += this.generateTableHeader(export_type); //OPEN TABLE TAG
            html += this.generateTableSubheader(export_type, store.getters.translate(text), headers.length);
            //HEADER
            html += this.generateAdvancedHeaders(headers);
            //DATA
            data.forEach((record) => {
                html += this.generateAdvancedRow(record, headers);
            });
            html += '</table>'; //CLOSE TABLE TAG
            html += '</td></tr>'; //CLOSE TR/TD IN MAIN TABLE
        }

        return html;
    },
    generateBooleanRow(export_type, key, value) {
        if(value) {
            if(export_type === 'excel') {
                return this.generateSimpleRow(key, store.getters.translate('true'));
            }
            else {
                return this.generateSimpleRow(key, this.true_checkbox);
            }
        }
        else {
            if(export_type === 'excel') {
                return this.generateSimpleRow(key, store.getters.translate('false'));
            }
            else {
                return this.generateSimpleRow(key, this.false_checkbox);
            }
        }
    },
    generateTableHeader(export_type) {
        if(export_type === 'excel') {
            return '<table border="2">';
        }
        else {
            return '<table style="border-spacing: 0px; -webkit-border-spacing: 0px; border-collapse: collapse; -webkit-border-collapse: collapse; width: 100%;">';
        }
    },
    generateTableSubheader(export_type, text, colspan = 2) {
        return '<tr><th colspan="' + colspan + '" style="text-align: center; color: ' + this.getHexRgbColor("white") + '; background-color: ' + this.getHexRgbColor("lightskyblue", export_type) + ';">' + text + '</th></tr>';
    },
    generateSimpleRow(key, value) {
        if (value == null) {
            value = '';
        }
        return '<tr><td>' + store.getters.translate(key) + ':</td><td>' + value + '</td></tr>';
    },
    generateAdvancedRow(data, headers) {
        let html = '<tr>';
        for (let i = 0; i < headers.length; i++) {
            if (data[headers[i]] == null) {
                data[headers[i]] = '';
            }
            if (data.person && data.person[headers[i]] == null) {
                data.person[headers[i]] = '';
            }
            if(headers[i] === 'status' || headers[i] === 'end_result') {
                html += '<td>' + store.getters.translate(data[headers[i]]) + '</td>';
            }
            else if(this.person_fields.includes(headers[i]) && data.person) {
                html += '<td>' + data.person[headers[i]] + '</td>';
            }
            else {
                html += '<td>' + data[headers[i]] + '</td>';
            }
        }
        html += '</tr>';
        return html;
    },
    generateAdvancedHeaders(headers) {
        let html = '<tr>';
        for (let i = 0; i < headers.length; i++) {
            html += '<th style="text-align: center;">' + store.getters.translate(headers[i]) + '</th>';
        }
        html += '</tr>';
        return html;
    },
    generateResultsRow(export_type, record_result) {
        let html = '<tr><td colspan="' + this.exam_table_data.length + '" style="padding: 0;">'; //OPEN TR/TD IN EXAMS TABLE
        html += this.generateTableHeader(export_type); //OPEN RESULTS TABLE TAG
        html += '<tr>'; //OPEN HEADER TR
        record_result.scheme.scheme_sessions.forEach((scheme_session) => {
            html += '<td style="text-align: center;">' + scheme_session.name + ' (' + scheme_session.cesuur + ')' + '</td>';
        });
        html += '</tr><tr>'; //CLOSE HEADER TR, OPEN BODY TR
        record_result.scheme.scheme_sessions.forEach((scheme_session) => {
            let result_found = false;
            record_result.results.forEach((exam_candidate_session) => {
                if(exam_candidate_session.scheme_session_id === scheme_session.id) {
                    result_found = true;
                    let background_color = this.backgroundColor(scheme_session.cesuur, exam_candidate_session);
                    html += '<td style="text-align: center; color: ' + this.getHexRgbColor("white") + '; background-color: ' + this.getHexRgbColor(background_color) + ';">' + exam_candidate_session.result + '</td>';
                }
            });
            if(!result_found) {
                html += '<td style="text-align: center; color: ' + this.getHexRgbColor("black") + '; background-color: ' + this.getHexRgbColor("white") + ';">-</td>';
            }
        });
        html += '</tr>'; //CLOSE BODY TR
        html += '</table>'; //CLOSE RESULTS TABLE TAG
        html += '</td></tr>'; //CLOSE TR/TD IN EXAMS TABLE
        html += '<tr><td colspan="' + this.exam_table_data.length + '" style="padding: 0;"/></tr>'; //ADD EMPTY LINE
        return html;
    },
    getPlannerEvent(id, resourceId, date, start_time, end_time, title, color, description = null) {
        return {
            "id": id,
            "resourceId": resourceId,
            "allDay": false,
            "start": moment(date + " " + start_time, "DD-MM-YYYY HH:mm").toDate(),
            "end": moment(date + " " + end_time, "DD-MM-YYYY HH:mm").toDate(),
            "title": title,
            "color": color,
            "description": description,
            "resourceEditable": false
        };
    },
    generateTimes() {
        let times = [];
        times[0] = "08:00";
        for (let i = 1; i < 120; i++) {
            times[i] = moment(times[i-1], "HH:mm").add({ minute: 5 }).format("HH:mm");
        }
        return times;
    },
    getEmptyPlannerTableRow(id, counter, duration, title, color) {
        return '<td class="pa-2 draggable-class" id="' + id + '_' + counter + '" ' +
            'style="border:1px solid grey; background-color: white; cursor: pointer; height: 40px;" ' +
            'data-event=\'{"id": "' + id + '", "resourceId": "' + counter + '", ' +
            '"duration": "' + duration + '", "title": "' + title + '", "color": "' + color + '", ' +
            '"resourceEditable": false}\'></td>';
    },
    getFilledPlannerTableRow(id, counter, duration, title, color) {
        return '<td class="pa-2 draggable-class" id="' + id + '_' + counter + '" ' +
            'style="border:1px solid grey; background-color: ' + color + '; cursor: pointer; height: 40px;" ' +
            'data-event=\'{"id": "' + id + '", "resourceId": "' + counter + '", ' +
            '"duration": "' + duration + '", "title": "' + title + '", "color": "' + color + '", ' +
            '"resourceEditable": false}\'>' + title + '</td>';
    }
}

export default plannerFunctions